<template>
  <v-app id="ui" fluid app tag="section">
    <v-row justify="center" class="centerTop">
      <v-col cols="5">
        <base-material-card
          color="#00bbff"
          title="Change Password"
          class="px-5 py-3"
          icon="mdi-key-change"
          id="white"
        >
          <v-card-text class="px-0 pb-0">
            <v-sheet>
              <v-form ref="changeps">
                <v-text-field
                  label="New Password"
                  v-model="password"
                  :rules="passwordRules"
                  type="password"
                  class="purple-input"
                />
                <v-text-field
                  label="Retype Password"
                  v-model="newpassword"
                  :rules="passwordRules"
                  type="password"
                />
                <br />
                <v-btn
                  block
                  color="primary"
                  :loading="loading"
                  :disabled="loading"
                  @click="changePassword"
                >Change Password</v-btn>
              </v-form>
              <br />
            </v-sheet>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>

    <!-- <template slot="default">
      <div id="bg"></div>
      <div id="overlay"></div>
    </template>-->
  </v-app>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "ForgotPassword",
  data() {
    return {
      loading: false,
      password: "",
      newpassword: "",
      passwordRules: [
        value => !!value || "Password is required.",
        value =>
          (value && value.length >= 6) ||
          "Password must be 6 characters or more."
      ],
      m_notification: []
    };
  },
  methods: {
    ...mapMutations(["SET_NOTIFICATION","UPDATE_PASSWORD_CHANGED"]),
    setNotification(t, m) {
      this.m_notification["msg"] = m;
      this.m_notification["type"] = t;
      this.$store.commit("SET_NOTIFICATION", { msg: m, type: t }); // this.m_notification);
    },
    changePassword() {
      if (this.newpassword != this.password) {
        this.setNotification(
          "error",
          "Password entered does not match retyped password."
        );
        return;
      }

      if (this.$refs.changeps.validate()) {
        this.loading = true;
        this.$http
          .post("/Postmanageuser", {
            UserID: this.$store.state.session.userid,
            username: this.$store.state.session.username,
            FullName: "",
            Userposition: "",
            Phonenumber: "",
            emailaddress: "",
            Delete: "0",
            Resetpassword: "0",
            Changepassword: "1",
            Newpassword: this.password,
            SetupUsername: this.$store.state.session.username
          })
          .then(res => {
            if (res.status == 200) {
              if (res.data.resultDesc == "Error") {
                this.setNotification("error", res.data.message);
              } else {
                this.$store.commit("UPDATE_PASSWORD_CHANGED", true);
                this.setNotification(
                  "success",
                  "Password has been changed. Your new password will take effect on next login."
                );
                this.$router.push("/account/dashboard");
              }
            } else {
              this.setNotification(
                "error",
                "Failed to change password. Please try again."
              );
            }
            this.loading = false;
            this.$refs.changeps.reset();
          })
          .catch(err => {
            this.setNotification(
              "error",
              "Failed to change password. Please try again."
            );
            this.loading = false;
          });
      }
    }
  },
  computed: {
    ...mapState(["session", "notification"])
  }
};
</script>

<style scoped>
#ui {
  background: #eee;
}

#white {
  background: #fff !important;
  z-index: 102020;
  min-width: 200px;
}

.centerTop {
  margin-top: 4% !important;
}
</style>
